import { Typography } from '../Typography/Typography.js';
import { getTabStyles } from './TabStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Tab = _ref => {
  let {
    children,
    text,
    selected = false,
    tabId,
    onClick,
    ...rest
  } = _ref;
  const setSelected = e => onClick === null || onClick === void 0 ? void 0 : onClick(tabId, e);
  return jsx(Typography, {
    bold: true,
    role: "tab",
    title: text,
    variant: "body1",
    "aria-label": text,
    component: "button",
    "aria-selected": selected,
    css: getTabStyles(selected),
    onClick: setSelected,
    ...rest,
    children: children
  });
};

export { Tab };
//# sourceMappingURL=Tab.js.map
